<script lang="ts" setup>
import NewCatalogMenuBox from '~/components/new-catalog-menu/NewCatalogMenuBox.vue'
</script>

<template>
  <NewCatalogMenuBox>
    <div
      class="
        custom-scroll relative h-[calc(100vh-180px)] overflow-x-hidden overflow-y-scroll pb-48
        md:h-[calc(100vh-118px)] md:overflow-y-auto
      "
    >
      <slot />
    </div>
  </NewCatalogMenuBox>
</template>

<style lang="scss" scoped>
@use 'assets/css/custom-scroll';
</style>
